module.exports = __webpack_public_path__ + "img/reaction14.6f5e800b.png";